<field-time-readonly *ngIf="field.readonly; else editable" [field]="field"></field-time-readonly>
<ng-template #editable>
  <field-time-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-time-single>
</ng-template>
